export class DataCatalogSubjectSet {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allAuthenticated",
            "baseName": "allAuthenticated",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "include",
            "baseName": "include",
            "type": "Array<DataCatalogSubjectRef>",
            "format": ""
        },
        {
            "name": "exclude",
            "baseName": "exclude",
            "type": "Array<DataCatalogSubjectRef>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogSubjectSet.attributeTypeMap;
    }
    constructor() {
    }
}
